/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「地址的组件」
 */
<template>
  <main class="cAddress-container">
    <section class="main-list">
      <cInputTitle text="郵便番号（ハイフンなし）"></cInputTitle>
      <div class="postalCode-list">
        <cNumInput
          class="postalCode-item"
          v-model="address_obj.postalCode"
          placeholder="1020073"
          oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 7) value = value.slice(0, 7)"
          @blur="getAddress"
          :disabled="showPostalPopup"
        ></cNumInput>
        <cRoundButton
          class="postalCode-item"
          :disabled="checkBnt"
          text="住所を自動入力"
          @clickbtn="getAddress(true)"
        ></cRoundButton>
      </div>
    </section>
    <section class="main-list">
      <cInputTitle text="都道府県"></cInputTitle>
      <cDropDown
        placeholder="選択してください"
        :value="address_obj.address1"
        @clickbtn="opencloseDuDaoFu(true)"
      ></cDropDown>
    </section>
    <section
      class="main-list"
      v-for="(item, index) in inputBoxArr"
      :key="index"
    >
      <cInputTitle :text="inputLabelArr[index]"></cInputTitle>
      <cAddressInput
        :class="{'cTextInput-container-white':item.key=='house_number'}"
        :placeholder="item.placeholder"
        v-model.trim="item.value"
        :message="item.message"
        :maxlength="50"
        :formatError="item.formatError"
        @blur="handleBlur(index)"
        @input="
          (value) => {
            handleInput(value, index);
          }
        "
      ></cAddressInput>
    </section>

    <cAddressPopup
      :show="showAddressPopup"
      :selectdata="DuDaoFuArr"
      @clickcancel="selectedDuDaoFu"
      @clickclose="opencloseDuDaoFu(false)"
      @clickselect="selectDuDaoFu"
    ></cAddressPopup>
    <cPostalPopup
      :show="showPostalPopup"
      :selectdata="postalArr"
      @clickclose="closePopup"
      @clickselect="SelectPostal"
      :title="searchingText"
      :tips="popupTips"
      :status="popupStatus"
    ></cPostalPopup>
  </main>
</template>

<script>
import cAddressPopup from '../Select/cSinglePopup';
import cPostalPopup from '../Select/cPostalPopup';
import cAddressInput from '../Input/cAddressInput';
import { COMMON_JP } from '../../utils/custom_language_jp';
import { checkJpText } from '../../utils/common-api';
export default {
  props: ['address_obj'],
  data() {
    return {
      showPostalPopup: false,
      showAddressPopup: false,
      searchingText: '検索中',
      postalArr: [],
      DuDaoFuArr: this.commonJs.deepCopy(this.commonData.areaData),
      DuDaoItem: {},
      inputLabelArr: [
        '市区町村・町域名',
        '番地（丁目、番、号はハイフンで入力）',
        '建物名・部屋番号等'
        // '建物名・部屋番号等（カナ）'
      ],
      inputBoxArr: [
        {
          key:'area',
          placeholder: '千代田区九段北',
          value: '',
          message: COMMON_JP.ADDR_FORMAT_ERROR_30FC,
          formatError: false
        },
        {
          key:'street_number',
          placeholder: '1-2-3',
          value: '',
          message: COMMON_JP.ADDR_FORMAT_ERROR_FF0D,
          formatError: false
        },
        {
          key:'house_number',
          placeholder: 'ハッシュビル',
          value: '',
          message: COMMON_JP.ADDR_FORMAT_ERROR_FF0D_30FC,
          formatError: false
        },
/*        {
          placeholder: 'ハッシュビル',
          value: '',
          message: COMMON_JP.ADDRESS2_MSG,
          formatError: false
        }*/
      ],
      popupTips: '',
      popupStatus: 'start',
      oldCode:'',
      validCode:false
    };
  },
  activated() {
    // eslint-disable-next-line
    let arr = ['address2', 'housenumber', 'roomnumber'];
    arr.map((item, index) => {
      this.inputBoxArr[index].value = this.address_obj[item];
    });
  },
  components: { cAddressPopup, cPostalPopup, cAddressInput },
  created(){
    // 1个人 2法人
    let type =  this.commonJs.getLocalData('applyTypeId')
     
    this.inputBoxArr.map(item=>{
      if(item.key == 'house_number'){
        item.placeholder = 'ハッシュマンション203'
        
        if(type == 2 && this.$route.path != '/transactionManager'){
          item.placeholder = 'ハッシュビル'
        }
      }
    })
  },
  computed: {
    checkBnt() {
      return (
        this.address_obj.hasOwnProperty('postalCode') &&
        this.address_obj.postalCode.length < 7
      );
    }
  },
  methods: {

    // 搜索邮政编码地址
    getAddress(isClick = false) {

      if(this.address_obj.postalCode.length != 7) return

      //检测到郵便番号未变更
      if(this.oldCode == this.address_obj.postalCode && !isClick && this.validCode) return

      this.validCode = false
      
      this.searchingText = '検索中...';
      this.showPostalPopup = true;
      this.popupTips = '';
      this.popupStatus = 'start';
      
      this.axios
        .get('search/address', {
          params: { zipcode: this.address_obj.postalCode.trim() }
        })
        .then((resp) => {

          this.popupStatus = 'end';

          if (resp.data.STATUS == 'OK') {

            this.postalArr = resp.data.DATA.map((item) => {
              item.text = item.address1 + item.address2 + item.address3;
              return item;
            });
            if (this.postalArr.length == 0) {
              this.popupTips = '登録のない郵便番号です。再度ご確認の上、改めてご入力ください。';
            } else {
              this.popupTips = '以下から、お客様の住所を選択してください';
              this.validCode = true
            }
          } else {
            this.closePopup();
            this.postalArr = [];
          }
          this.searchingText = '住所検索結果';
          this.oldCode = this.commonJs.deepCopy(this.address_obj.postalCode)
        })
        .catch((error)=>{
          this.closePopup();
        });
    },
    closePopup() {
      this.showPostalPopup = false;
      if(this.postalArr.length == 0){
        this.address_obj.postalCode = ''
      }
    },
    SelectPostal(item) {
      this.DuDaoFuArr = this.commonJs.clearSelected(this.DuDaoFuArr);
      this.address_obj.searchedPostal = item;
      if (this.judgeHaveDuDaoFu(item)) {
        var status = this.DuDaoFuArr.find((ite) => {
          return ite.value == item.address1;
        });
        if (status) {
          this.address_obj.address1 = status.value;
          this.address_obj.address2 = item.address2 + item.address3;
          this.inputBoxArr[0].value = item.address2 + item.address3;
        }
      }
    },
    judgeHaveDuDaoFu(data) {
      var textArr = ['都', '道', '府', '県'];
      return textArr.some((item) => {
        return data.address1.indexOf(item) != -1;
      });
    },
    // 打开都道府県下拉选择弹框
    opencloseDuDaoFu(falg) {
      if (falg && this.address_obj.address1) {
        this.DuDaoFuArr = this.DuDaoFuArr.map((item) => {
          if (item.value == this.address_obj.address1) {
            item.isActive = true;
          }
          return item;
        });
      }
      this.showAddressPopup = falg;
    },
    selectDuDaoFu(item) {
      this.DuDaoFuArr = this.commonJs.clearSelected(this.DuDaoFuArr);
      item.isActive = true;
    },
    selectedDuDaoFu(falg) {
      if (falg) {
        var status = this.DuDaoFuArr.find((ite) => {
          return ite.isActive;
        });
        this.DuDaoItem = status;

        if (status) {
          this.address_obj.address1 = status.value;
          let searchedPostal = this.address_obj.searchedPostal;
          let newSearchedPostal = {};
          if (searchedPostal) {
            newSearchedPostal = {
              address1: status.value,
              address2: searchedPostal.address2 ? searchedPostal.address2 : '',
              address3: searchedPostal.address3 ? searchedPostal.address3 : '',
              area_cd: status.id,
              text: ''
            };
          } else {
            newSearchedPostal = {
              address1: status.value,
              address2: '',
              address3: '',
              area_cd: status.id,
              text: ''
            };
          }
          this.address_obj.searchedPostal = newSearchedPostal;
        }
      } else {
        this.DuDaoFuArr = this.commonJs.clearSelected(this.DuDaoFuArr);
      }
    },
    // 转换片假名
    hiraganaToKatagana(src) {
      var newStr = '';
      for (var i = 0; i < src.length; ++i) {
        if (src[i].match(/[\u3041-\u3096]/)) {
          newStr += String.fromCharCode(src.charCodeAt(i) + 0x60);
        } else {
          newStr += src[i];
        }
      }
      return newStr;
    },

    handleBlur(index) {
      let data = this.inputBoxArr[index];
      data.value = this.commonJs.halfToFullangle(data.value,index); //半角转全角
      if (index == 3) {
        if (!data.value.match(/[^\u3040-\u30FF]+/)) {
          data.value = this.hiraganaToKatagana(data.value);
        }
        let status =
          data.value.replace(
            /[\u30A1-\u30FC\uff10-\uff19\u30fc\u0020\u0030]/g,
            ''
          ) == ''
            ? true
            : false;
        //全部是全角
        data.formatError = !status;
      }
      if ([2, 3].includes(index)) {
        if (data.value == '') {
          data.formatError = false;
        }
      }
      this.handleInput(data.value, index);

      if(!data.formatError){
        checkJpText(data.value).then(obj=>{
            if(obj.status){
              data.formatError=obj.status;
              data.message=obj.msg
            }
        })
      }

    },
    handleInput(value, index) {
      let data = this.inputBoxArr[index];
      if ([0, 2].includes(index)) {
        data.formatError = !this.commonJs.verifyInputText(value, 3);
        this.inputBoxArr[index].message=index==2?COMMON_JP.ADDR_FORMAT_ERROR_FF0D_30FC:COMMON_JP.ADDR_FORMAT_ERROR_30FC;
      } else if (index == 1) {
        data.formatError = !this.commonJs.verifyInputText(value, 7);
            this.inputBoxArr[1].message=COMMON_JP.ADDR_FORMAT_ERROR_FF0D;
      } else if (index == 3) {
        let status =
          value.replace(
            /[\u30A1-\u30FC\uff10-\uff19\u30fc\u0020\u0030]/g,
            ''
          ) == ''
            ? true
            : false;
        data.formatError = !status;
      }

      this.clickbtn(value, index);
    },
    clickbtn(value, index) {
      let arr = ['address2', 'housenumber', 'roomnumber'];
      this.address_obj[arr[index]] = value;
      this.$emit('update_address_obj', {
        address_obj: this.address_obj,
        inputBoxArr: this.inputBoxArr
      });
    }
  }
};
</script>

<style lang="less"  scoped>
.cAddress-container {
  .main-list {
    margin-bottom: 0.27rem;
  }
  .postalCode-list {
    display: flex;
    justify-content: space-between;
    .postalCode-item {
      width: 47%;
    }
  }
.cTextInput-container-white{
  /deep/ input{
    background: #FFFFFF;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/Container/cAddress.vue